export default __webpack_public_path__ + "static/heat_exchanger_b.158f702d22fbbd92ea3df37c0b4b644c.png";